<template>
	<div class="store-row">
		<div class="grid-columns-2">
			<div
				v-if="distanceSet(store)"
				class="label flex"
			>
				<TnIcon
					class="margin-right-s"
					name="location"
				/>
				<TnParagraph
					size="xs"
					class="label"
				>
					{{ store.distanceFromUser }} km
				</TnParagraph>
			</div>

			<TnParagraph
				size="xs"
				class="label"
			>
				{{ openingHours(store) }}
			</TnParagraph>
		</div>
		<TnButton
			size="s"
			@click="$emit('reserve', store)"
			:disabled="!inStock(store)"
			class="margin-s"
		>
			Reserver
		</TnButton>
	</div>
</template>

<script setup>
defineProps({
	store: Object,
});

defineEmits(["reserve"]);

import { todaysClosingTime } from "~/helpers/ecommerce/clickAndCollect/clickAndCollectMessageUtil";

const distanceSet = (store) => store.distanceFromUser !== null;
const openingHours = (store) => todaysClosingTime(store);
const inStock = (store) => store.inventory != null && store.inventory?.quantity > 0;
</script>

<style scoped lang="scss">
.store-row {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 16px; // Optional: adds spacing if name is long
}

.flex {
	display: flex;
}

.label {
	align-items: center;
	border-radius: 4px;
	display: flex;
	justify-content: center;
	padding: 4px;
	margin-top: 2px;
}

.info-row {
	display: flex;
	flex-wrap: wrap;
	gap: 16px;
}

.grid-columns-2 {
	display: grid;
	grid-template-columns: 1fr 1fr;

	@media (max-width: 768px) {
		grid-template-columns: 1fr;
		grid-template-rows: auto auto;

		.content-right {
			justify-self: center;
			margin-top: 16px;
		}
	}
}
</style>
